// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"538b5f4e","420":"68bf26dd","539":"6a19752c","637":"d9b15179","644":"a42f262a","775":"c42064dc","857":"e4eda24a","884":"b6d1458d","945":"00c7d6a9"}[chunkId] + ".js";
};